export class ImosDropdown extends HTMLElement {
  private open = false;
  private boundClose = this.handleOutsideClick.bind(this);

  connectedCallback(): void {
    const trigger = this.querySelector('[data-trigger]');
    trigger?.addEventListener('click', () => this.toggle());
  }

  disconnectedCallback(): void {
    document.removeEventListener('click', this.boundClose);
  }

  private toggle(): void {
    this.open = !this.open;
    this.apply();
  }

  private close(): void {
    this.open = false;
    this.apply();
  }

  private apply(): void {
    const content = this.querySelector('[data-content]') as HTMLElement | null;
    if (content) {
      content.style.display = this.open ? '' : 'none';
    }

    if (this.open) {
      // Defer so the current click event doesn't immediately close
      requestAnimationFrame(() => {
        document.addEventListener('click', this.boundClose);
      });
    } else {
      document.removeEventListener('click', this.boundClose);
    }
  }

  private handleOutsideClick(event: Event): void {
    if (!this.contains(event.target as Node)) {
      this.close();
    }
  }
}

customElements.define('imos-dropdown', ImosDropdown);
